import {json} from "d3-fetch";
import {create, select, selectAll} from 'd3-selection';
import {group, extent, max} from "d3-array";
import {scaleTime, scaleLinear, scaleOrdinal} from "d3-scale";
import {axisBottom, axisLeft} from "d3-axis";
import {line, curveCardinal} from "d3-shape";
import {format} from "d3-format";
import {timeParse} from "d3-time-format";
import {transition} from "d3-transition"; // ignore unused import error

// set the dimensions and margins of the graph
const margin = {top: 20, right: 20, bottom: 20, left: 60};
const width = 450 - margin.left - margin.right;
let isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;
let reduceHeight = 0;
let svgViewboxY =  315;
if(!isMobile) {
    reduceHeight = 50;
    svgViewboxY = 270;
}    
const height = (300 - margin.top - margin.bottom - reduceHeight) ;

let gatewayTimeSavingsSVG;

const renderGatewayTimeSavings = async () => {
    if ($(".gateway-time-savings-widget").length <= 0 ) {
        return;
    }

    await json(`/wp-json/data/time-savings`)
        .then(async (res) => {
            let {data, legend} = res;
            // format the data
            const parseTime = timeParse("%Y");
            data = data.map(d => {
                return {
                    year: parseTime(d.year),
                    popType: d.population_type,
                    popNumber: +d.population_number
                };
            });

            // Create the Chord Diagram SVG container
            gatewayTimeSavingsSVG = create("svg")
                .attr("style", `width: 100%; height: 100%; font: 10px sans-serif;`)
                .attr("viewBox", "0 0 450 "+svgViewboxY)
                .attr("preserveAspectRatio", "xMinYMin");

            gatewayTimeSavingsSVG = renderGatewayTimeSavingsDiagram(data, legend);

            if (gatewayTimeSavingsSVG) {
                let minutes = (new Date().getFullYear() - 2011) * 4.22 * 100;
                minutes = Math.pow(minutes, 1.5);
                let estimateTime = minToDays(minutes.toFixed(2));
                $('.gateway-time-savings-widget .block.impact .title').text(estimateTime);
                select(".gateway-time-savings-widget #gateway-time-savings-diagram")
                    .node()
                    .appendChild(gatewayTimeSavingsSVG.node());
            }
        })
        .catch(error => {
            console.error('error', error)
        });
}

const renderGatewayTimeSavingsDiagram = (data, legend) => {
    // color palette
    let colors = ["#7f1a5d"];
    const color = scaleOrdinal().range(colors);

    // Generate the Legend html
    if (window.gatewaySavings && window.gatewaySavings.legend) {
        let legendHtml = '';
        window.gatewaySavings.legend.forEach((item, index) => {
            if (item && item.length > 0 && item !== " ") { 
                legendHtml += `<li><span class="legend-color" style="background-color: ${colors[index]}; border: 1px solid ${colors[index]};"></span><span class="legend-copy">${item}</span></li>`;
            }
        });
        select(".gateway-time-savings-widget .legend ul").html(legendHtml);
    }

    const svg = gatewayTimeSavingsSVG
        .append("g")
        .attr("transform", `translate(${margin.left}, ${margin.top})`);

    //pivot the data
    const dataGrouped = group(data, d => d.popType)

// X scale and Axis
    const xScale = scaleTime()
        .domain(extent(data, d => d.year)).nice()
        .range([0, width]);

    svg
        .append('g')
        .attr("transform", `translate(0, ${height})`)
        .call(axisBottom(xScale).tickSize(0).tickPadding(8));

// Y scale and Axis
    const formatter = format("~s")
    const yScale = scaleLinear()
        .domain([0, max(data, d => d.popNumber)])
        .range([height, 0]);
    svg
        .append('g')
        .call(axisLeft(yScale).ticks(6).tickSize(0).tickPadding(6).tickFormat(formatter))
        .call(d => d.select(".domain").remove());

// set horizontal grid line
    const GridLine = () => axisLeft().scale(yScale);
    svg
        .append("g")
        .attr("class", "grid")
        .call(GridLine()
            .tickSize(-width, 0, 0)
            .tickFormat("")
            .ticks(6)
        );

// create line
    const lines = svg
        .selectAll("lines")
        .data(dataGrouped)
        .join("path")
        .attr("fill", "none")
        .attr("stroke", d => color(d[0]))
        .attr("stroke-width", 2)
        .attr("opacity", 0)
        .attr("d", function (d) {
            return line()
                .curve(curveCardinal)
                .x(d => xScale(d.year))
                .y(d => yScale(d.popNumber))
                (d[1])
        });

    // animate the lines
    // each line will be drawn in sequence
    lines.transition()
        .duration(1000)
        .attr("opacity", 1);

// set Y axis label
    const yAxis = svg
        .append('g')
        .attr("class", "y-axis-label");

    yAxis
        .append("text")
        .attr("class", "chart-label")
        .attr("x", -50)
        .attr("y", -(margin.top / 9))
        .attr("text-anchor", "start");

    if (window.gatewaySavings && window.gatewaySavings.yAxis) {
        yAxis
            .select(".chart-label")
            .text(window.gatewaySavings.yAxis);
    }

// set X axis label
    const xAxis = svg
        .append('g')
        .attr("class", "x-axis-label");

    xAxis
        .append("text")
        .attr("class", "chart-label")
        .attr("x", width / 2 )
        .attr("y", height + margin.bottom + 15)
        .attr("text-anchor", "center");

    if (window.gatewaySavings && window.gatewaySavings.xAxis) {
        xAxis
            .select(".chart-label")
            .text(window.gatewaySavings.xAxis);
    }

    return Object.assign(
        gatewayTimeSavingsSVG,
        {
            async update(data) {
                renderGatewayTimeSavingsDiagram(data);
            }
        });
}

jQuery(document).ready(function () {
    renderGatewayTimeSavings();
});

function minToDays(min) {
    let days = Math.floor(min / 1440);
    let remainingTime = parseInt(min - Math.floor((days *1440)));
    let hours = Math.floor((remainingTime / 60));
    let remainingMin = Math.floor(remainingTime - (hours*60));
    return `${days} day(s) and ${hours} hour(s) and ${remainingMin} minutes(s)`;
  }

function timeSavingConvert(n) {
    // Store the input number of minutes in a variable num
    var num = n;
    // Calculate the total hours by dividing the number of minutes by 60
    var hours = (num / 60);
    // Round down the total hours to get the number of full hours
    var rhours = Math.floor(hours);
    // Calculate the remaining minutes after subtracting the full hours from the total hours
    var minutes = (hours - rhours) * 60;
    // Round the remaining minutes to the nearest whole number
    var rminutes = Math.round(minutes);
    // Construct and return a string representing the conversion result
    return rhours + " Hour(s) " + rminutes + " Minute(s)";
}
